export default "__VITE_ASSET__Bk44cD6N__"